<template>
  <Teleport to="body">
    <Transition
        enter-active-class="transition duration-300 ease-out"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition duration-300 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
      <!-- Backdrop Layout Layer -->
      <div
          v-if="isOpen"
          class="modal"
          :class="{'modal-open': isOpen}"
          @click.self="closeModal"
      >
        <!-- Modal Window Container Box -->
        <Transition
            enter-active-class="transition duration-200 ease-out transform"
            enter-from-class="scale-95 opacity-0"
            enter-to-class="scale-100 opacity-100"
            leave-active-class="transition duration-150 ease-in transform"
            leave-from-class="scale-100 opacity-100"
            leave-to-class="scale-95 opacity-0"
        >
          <div class="modal-box">
              <!-- Header Section Slot -->
              <header class="flex items-center justify-between  border-gray-200 p-2">
                <slot name="header">
                  <h3 class="text-lg font-semibold text-gray-900">{{ modalTitle }}</h3>
                </slot>
                <button
                    @click="closeModal"
                    class="text-2xl font-light text-gray-400 hover:text-gray-600 transition-colors"
                    aria-label="Close modal"
                >
                  &times;
                </button>
              </header>

              <!-- Main Scrollable Content Slot Body -->
              <section class="max-h-[75vh] overflow-y-auto p-2 text-sm text-gray-600">
                <slot></slot>
              </section>

              <!-- Action Buttons Footer Slot -->
              <footer
                  v-if="$slots.footer"
                  class="flex justify-end gap-3 border-t border-gray-200 bg-gray-50 px-5 py-4"
              >
                <slot name="footer"></slot>
              </footer>
            </div>

        </Transition>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import {watch} from 'vue'

const props = defineProps({
  isOpen: {type: Boolean, required: true},
  modalTitle: {type: String},
  maxWidth: {type: String, default: '500px'}
})

const emit = defineEmits(['close'])

const closeModal = () => {
  emit('close')
}

// Lock window scrolling during modal viewing state
watch(() => props.isOpen, (newValue) => {
  if (newValue) {
    document.body.classList.add('overflow-hidden')
  } else {
    document.body.classList.remove('overflow-hidden')
  }
}, {immediate: true})
</script>
